import * as PIXI from "pixi.js";
import TextureManager from "../../managers/TextureManager";
import InfoSlider from "./InfoSlider";


export default class InfoPage extends PIXI.Sprite {
  private InfoSlider = InfoSlider.getInstance();
  constructor(path: string) {
    super();
    this.generate(path)
  }
  private generate(path) {
    this.texture = TextureManager.getTexture(path);
    this.anchor.set(.5);
    this.scale.set(.42);
    this.x = this.InfoSlider.x;
    this.y = this.InfoSlider.y;
  }
}